<template>
  <div class="AboutMenu">
    <DropdownMenu :dropped.sync="isDropped">
      <span slot="label" class="AboutMenu__Label">{{
        $t("top.about.info")
      }}</span>
      <div slot="dropdown" class="AboutMenu__List">
        <button
          v-if="lang === 'en'"
          class="AboutMenu__List-Item"
          @click="goToSelectedSite('/blog/crypto-portfolio-tracker-is-more-important-than-you-think')"
        >
          {{ "Blog" }}
        </button>
        <button class="AboutMenu__List-Item" @click="goToSelectedSite('/faq')">
          {{ $t("top.about.FAQ") }}
        </button>
        <button
          class="AboutMenu__List-Item"
          @click="goToSelectedSite('/contact')"
        >
          {{ $t("top.about.contact") }}
        </button>
        <button
          class="AboutMenu__List-Item"
          @click="goToSelectedSite('/terms')"
        >
          {{ $t("top.about.terms") }}
        </button>
        <button
          class="AboutMenu__List-Item"
          @click="goToSelectedSite('/privacy')"
        >
          {{ $t("top.about.privacy") }}
        </button>
      </div>
    </DropdownMenu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DropdownMenu from "@/components/DropdownMenu";

export default {
  name: "AboutMenu",
  components: {
    DropdownMenu,
  },
  data() {
    return {
      isDropped: false,
    };
  },
  computed: {
    ...mapGetters({
      lang: "settings/lang",
    }),
  },
  methods: {
    goToSelectedSite(site) {
      this.isDropped = false;
      this.$router.push(site);
    },
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.AboutMenu {
  display: inline-block;
}

.AboutMenu__List {
  @include breakpoint-manual(min-width, $break-small) {
    width: 225px;
  }
}

.AboutMenu__List-Item {
  cursor: pointer;
  white-space: nowrap;
  padding: 5px 20px;
  display: block;
  color: #222;
  text-decoration: none;
  border: 0;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 16px;
  transition: background 0.1s;

  &[disabled] {
    background: transparent !important;
    color: #999 !important;
    cursor: not-allowed;
  }

  &:hover {
    color: $color-secondary;
    background: #f4f4f4;
  }

  em {
    float: right;
    font-weight: 300;
    margin-left: 5px;
    opacity: 0.5;
    font-style: normal;
  }

  a {
    color: #222;
    text-decoration: none;
  }
}
</style>
